module.exports = __webpack_public_path__ + "img/join_community.bdf423aa.svg";